import React from "react";

const VolLalinDalkot = () => {
  return (
    <div style={{ width: "100%", height: "600px" }}>
      <iframe
        title="Volume Lalin Dalam Kota"
        src="https://lookerstudio.google.com/embed/reporting/7651daeb-be31-423b-92a3-2660b6253606/page/CEZiE"
        width="100%"
        height="100%"
        style={{
          border: 0,
          overflow: "hidden",
        }}
        allowFullScreen
      ></iframe>
    </div>
  );
};

export default VolLalinDalkot;
